import { render, staticRenderFns } from "./BlockAction.vue?vue&type=template&id=553e3f34&"
import script from "./BlockAction.vue?vue&type=script&lang=js&"
export * from "./BlockAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports